import { ReactComponent as DTRK } from '../img/dtrk.svg';
import { ReactComponent as Zebra } from '../img/zebra.svg';
import { ReactComponent as Help } from '../img/help.svg';
import { ReactComponent as UpArrowHead } from '../img/drop_down_up.svg';
import { ReactComponent as DownArrowHead } from '../img/drop_down_down.svg';
import { ReactComponent as Download } from '../img/download.svg';
import styled from 'styled-components';

export const StyledDTRKIcon = styled(DTRK)`
  width: auto;
  display: flex; 
  margin: 10px;
  width: 50px;
`;
export const StyledZebraIcon = styled(Zebra)`
  width: auto;
  display: flex; 
  margin: 10px;
  width: 50px;
`;
export const HelpIcon = styled(Help)`
  width: auto;
  display: flex; 
  margin: 6px 2px 0 2px;
  height: 15px;
  fill: #8E8E8E;
`;
export const DropdownArrow = styled(UpArrowHead)`
  fill: #000000;
  width: 10px;
  height: 10px;
`
export const GreenArrowHead = styled(DownArrowHead)`
  fill: #00B400;
  height: 20px;
  margin: 6px;
`;
export const RedArrowHead = styled(UpArrowHead)`
  fill: #ED1C24;
  height: 20px;
  margin: 6px;
`;
export const DownloadIcon = styled(Download)`
  fill: #007ABA;
  height: 14px;
`;
